<script>
import {Link} from "@inertiajs/vue3";

export default {
	components: {
		Link
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		url: {
			type: [String, Boolean],
			required: false,
			default : ''
		}
	}
}
</script>
<template>
	<li class="dropdown" :class="{'active': active}">
		<button type="button" v-if="$props.url == false" class="dropdown-toggle" :class="{'active': active}" data-bs-toggle="dropdown" data-bs-auto-close="false" data-bs-display="static" :aria-expanded="active ? 'true' : 'false' ">
			<template v-if="$slots.icon">
				<slot name="icon"/>
				<span class="hide-menu">
					<slot name="label"/>
				</span>
			</template>

			<template v-if="!$slots.icon">
				<slot name="label"/>
			</template>
			<i class="bi bi-chevron-down dropdown-chevron"></i>
		</button>

		<Link v-if="$props.url != false" class="dropdown-toggle has-link" :class="{'active': active}" :href="url" data-bs-toggle="dropdown" data-bs-auto-close="false" data-bs-display="static" :aria-expanded="active ? 'true' : 'false' ">
			<template v-if="$slots.icon">
				<slot name="icon"/>
				<span class="hide-menu">
					<slot name="label"/>
				</span>
			</template>

			<template v-if="!$slots.icon">
				<slot name="label"/>
			</template>
			<i class="bi bi-chevron-down dropdown-chevron"></i>
		</Link>

		<ul :aria-expanded="active ? 'true' : 'false'" class="dropdown-menu" :class="{'show': active }">
			<li class="dropdown-header-label">
				<slot name="label"/>
			</li>
			<slot/>
		</ul>
	</li>
</template>